<template>
  <div
    :class="{
      'product-format': true,
      'on-offer': product.promotion,
    }"
  >
    <b-row>
      <b-col class="mb-1 mb-md-0">
        <b-badge
          v-if="product.statuslabels['Sold Out']"
          class="float-none"
          variant="danger"
          >Sold Out</b-badge
        >&nbsp;
        <b-badge
          v-if="product.statuslabels['Low Stock']"
          class="float-none"
          variant="warning"
          >Low Stock</b-badge
        >&nbsp;
        <b-badge
          v-if="product.statuslabels['On Allocation']"
          class="float-none"
          variant="warning"
          >On Allocation</b-badge
        >&nbsp;
        <b-badge
          v-if="product.statuslabels['Over Subscribed']"
          class="float-none"
          variant="warning"
          >Over Subscribed</b-badge
        >
      </b-col>
    </b-row>

    <b-row v-if="!trade">
      <b-col
        v-if="
          product.stock > 0 ||
          (product.stockstatus === 'Enquire' && product.price)
        "
        cols="12"
        md="4"
        lg="6"
        class="align-self-center product-format-detail"
      >
        <span v-if="product.stockstatus !== 'Stock' && !product.price">
          {{ product.range_from | currency }} -
          {{ product.range_to | currency }}
        </span>
        <span v-else>
          {{ product.price | currency }}
        </span>

        ({{ product.format }})

        <span v-if="product.was_price && product.mixed === ''" class="was-price"
          >(Was {{ product.was_price | currency }})</span
        >
      </b-col>
      <b-col
        cols="12"
        md="8"
        lg="6"
        class="align-self-center"
        v-if="
          product.stockstatus === 'Stock' ||
          product.stockstatus === 'Apply' ||
          product.stockstatus === 'Pre-Order'
        "
      >
        <div class="product-add-to-cart text-md-right" v-if="product.stock > 0">
          <form
            class="cart"
            method="post"
            enctype="multipart/form-data"
            @submit.prevent="addToBasket(product, add_qty)"
          >
            <div class="quantity float-left float-md-none">
              <label
                class="screen-reader-text"
                :for="'quantity_' + product.WCID"
                >{{ product.title }} quantity</label
              >
              <quantity instant v-model="add_qty" />
            </div>

            <button
              type="submit"
              name="add-to-cart"
              :value="product.WCID"
              :disabled="adding"
              v-if="product.stockstatus === 'Stock'"
              class="btn btn-primary btn-rounded float-right float-md-none"
            >
              Add

              <svg
                class="bi spin"
                :class="{ 'd-none': !adding }"
                width="1rem"
                height="1rem"
                fill="currentColor"
              >
                <use
                  xlink:href="/app/themes/jeroboams-2020/node_modules/bootstrap-icons/bootstrap-icons.svg#arrow-repeat"
                />
              </svg>

              <svg
                class="bi"
                :class="{ 'd-none': adding }"
                width="1rem"
                height="1rem"
                fill="currentColor"
              >
                <use
                  xlink:href="/app/themes/jeroboams-2020/node_modules/bootstrap-icons/bootstrap-icons.svg#arrow-right-circle"
                />
              </svg>
            </button>

            <button
              type="submit"
              name="add-to-cart"
              :value="product.WCID"
              :disabled="adding"
              v-if="product.stockstatus === 'Pre-Order'"
              class="btn btn-primary btn-rounded float-right float-md-none"
            >
              Pre-Order

              <svg
                class="bi spin"
                :class="{ 'd-none': !adding }"
                width="1rem"
                height="1rem"
                fill="currentColor"
              >
                <use
                  xlink:href="/app/themes/jeroboams-2020/node_modules/bootstrap-icons/bootstrap-icons.svg#arrow-repeat"
                />
              </svg>

              <svg
                class="bi"
                :class="{ 'd-none': adding }"
                width="1rem"
                height="1rem"
                fill="currentColor"
              >
                <use
                  xlink:href="/app/themes/jeroboams-2020/node_modules/bootstrap-icons/bootstrap-icons.svg#arrow-right-circle"
                />
              </svg>
            </button>

            <button
              type="submit"
              name="add-to-cart"
              :value="product.WCID"
              :disabled="adding"
              v-if="product.stockstatus === 'Apply'"
              class="btn btn-primary btn-rounded float-right float-md-none"
            >
              Apply

              <svg
                class="bi spin"
                :class="{ 'd-none': !adding }"
                width="1rem"
                height="1rem"
                fill="currentColor"
              >
                <use
                  xlink:href="/app/themes/jeroboams-2020/node_modules/bootstrap-icons/bootstrap-icons.svg#arrow-repeat"
                />
              </svg>

              <svg
                class="bi"
                :class="{ 'd-none': adding }"
                width="1rem"
                height="1rem"
                fill="currentColor"
              >
                <use
                  xlink:href="/app/themes/jeroboams-2020/node_modules/bootstrap-icons/bootstrap-icons.svg#arrow-right-circle"
                />
              </svg>
            </button>
          </form>
        </div>
      </b-col>
      <b-col v-if="product.stockstatus === 'Enquire'" class="text-right">
        <b-button variant="primary" rounded @click="showEnquire(product)"
          >Enquire for availability</b-button
        >
        <enquire-modal :product="product"></enquire-modal>
      </b-col>
    </b-row>
    <b-row v-else>
      <b-row>
        <b-col class="mb-1 mb-md-0">
          <b-badge
            v-if="product.statuslabels['Sold Out']"
            class="float-none"
            variant="danger"
            >Sold Out</b-badge
          >&nbsp;
          <b-badge
            v-if="product.statuslabels['Low Stock']"
            class="float-none"
            variant="warning"
            >Low Stock</b-badge
          >&nbsp;
          <b-badge
            v-if="product.statuslabels['Recommended']"
            class="float-none"
            variant="success"
            >Recommended</b-badge
          >&nbsp;
          <b-badge
            v-if="product.statuslabels['On Allocation']"
            class="float-none"
            variant="warning"
            >On Allocation</b-badge
          >&nbsp;
          <b-badge
            v-if="product.statuslabels['Over Subscribed']"
            class="float-none"
            variant="warning"
            >Over Subscribed</b-badge
          >
        </b-col>
      </b-row>
      <b-col>
        {{ product.format }}

        <span v-if="product.was_price && product.mixed === ''" class="was-price"
          >(Was {{ product.was_price | currency }})</span
        >
      </b-col>
      <b-col cols="6" lg="4" class="text-right">
        <wine-list-add-product :sku="product.id" :tech-sheet="false"></wine-list-add-product>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import Quantity from "@/components/Quantity";
import EnquireModal from "@/components/EnquireModalNormalised";

import WineListAddProduct from "@/components/winelist/WineListAddProduct";

export default {
  components: {
    Quantity,
    EnquireModal,
    WineListAddProduct,
  },
  props: {
    trade: {
      type: Boolean,
      default: false,
    },
    product: {
      type: [Object, Boolean],
      default: false,
    },
  },
  data() {
    return {
      add_qty: 1,
      adding: false,
    };
  },
  methods: {
    showEnquire(product) {
      this.$bvModal.show("enquire-modal-" + product.id);
    },
    addToBasket(product, quantity) {
      this.adding = true;
      return this.$store
        .dispatch("basket/add_item", {
          product_id: product.wcid,
          product_title: product.title,
          quantity,
        })
        .finally(() => {
          this.adding = false;
        });
    },
  },
};
</script>